import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { Button } from 'antd';

const APITopContent = () => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.content}>
      <div className={styles.leftContainer} id={'leftContainer'}>
        <h1 className={styles.title}>{t('Effortless Virtual Hairstyling with Hairpaca API')}</h1>
        <p>{t('Quick style previews, easy to use, and instant hairstyle changes —all in one API.')}</p>
        <div className={styles.btnContainer}>
          <Button
            className={styles.btn}
            onClick={() => {
              window.location.href = 'mailto:help.pumpsoul@gmail.com';
            }}
          >
            {'Contact us for the API'}
          </Button>
        </div>
      </div>

      <div className={styles.rightContainer}>
        <img style={{ width: '100%', objectFit: 'contain' }} src="/images/api/api-top-icon.webp" alt="api-top-icon" />
      </div>
    </div>
  );
};

export default APITopContent;
